import React from "react";
import "./footer.css";
import { Map } from "..";
import { servicesList } from "../../list";
import { Link } from "react-router-dom";

function Footer({ className }) {
  let classes = ["footer", className].join(" ");
  let services = [];
  let bussiness = [];

  servicesList["سرویس‌ها"].forEach((element, idx) => {
    services.push(
      <Link to={`/service-detail/${element.id}`} target="_blank" key={idx} disabled={element.underConstruction}>{element.title}</Link>
    );
  });

  servicesList["کسب‌و‌کار و تجارت"].forEach((element, idx) => {
    bussiness.push(
      <Link to={`/service-detail/${element.id}`} target="_blank" key={idx} disabled={element.underConstruction}>{element.title}</Link>
    );
  });

  return (
    <div className={classes}>
      <div className="main-footer">
        <div className="footer-descr">
          <div className="footer-logo"></div>
          <p>
            به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک
            گفته می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی
            برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده
            استفاده می نماید، تا از نظر گرافیکی نشانگر چگونگی نوع و اندازه فونت
            و ظاهر متن باشد. معمولا طراحان گرافیک برای صفحه‌آرایی، نخست از
            متن‌های آزمایشی و بی‌معنی استفاده می‌کنند تا صرفا به مشتری یا صاحب
            کار خود نشان دهند که صفحه طراحی یا صفحه بندی شده بعد از اینکه متن در
            آن قرار گیرد چگونه به نظر می‌رسد و قلم‌ها و اندازه‌بندی‌ها چگونه در
            نظر گرفته شده‌است.
          </p>
        </div>
        <div className="footer-navs">
          <div className="footer-navs-link">
            <h3>سرویس‌ها</h3>
            {services}
          </div>
          <div className="footer-navs-link">
            <h3>‌کسب‌وکار</h3>
            {bussiness}
          </div>
        </div>
        <div className="footer-info">
          <div className="info-row">
            <div className="icon pin-icon"></div>
            <p>
              تهران - خیابان بهشتی - خیابان پاکستان - کوچه ساوجی‌نیا - پلاک ۵
            </p>
          </div>
          <div className="info-row">
            <div className="icon email-icon"></div>
            <p className="english-state"><a href="mailto:info@map.ir?subject=%D8%AF%D9%85%D9%88%20%D8%B3%D8%B1%D9%88%DB%8C%D8%B3%E2%80%8C%D9%87%D8%A7&body=%D8%A7%D8%B1%D8%B3%D8%A7%D9%84%20%D8%B4%D8%AF%D9%87%20%D8%A7%D8%B2%20%D8%B5%D9%81%D8%AD%D9%87%20%D8%AF%D9%85%D9%88%20%D8%B3%D8%B1%D9%88%DB%8C%D8%B3%E2%80%8C%D9%87%D8%A7%3A%0D%0A%0D%0A%0D%0A" target="_blank" rel="noopener noreferrer">info@map.ir</a></p>
          </div>
          <div className="info-row">
            <div className="icon phone-icon"></div>
            <p><a href="tel:+98-21-42070300">021-42070300</a></p>
          </div>
        </div>
        <div className="map-wrapper"><Map /></div>
      </div>
      <div className="footer-footer">
        <div className="copyright">
          <div className="copyright-logo"></div>
          <p>
            کلیه حقوق معنوی در اختیار شرکت شیوه نرم افزار گستر آسیا می‌باشد.
          </p>
        </div>
        <div className="media-icons-row">
          <a className="social-link" href="https://twitter.com/map_ir_Official" target="_blank"
          rel="noopener noreferrer"><div className="twitter"></div></a>
          <a className="social-link" href="https://www.linkedin.com/company/map-ir/" target="_blank"
          rel="noopener noreferrer"><div className="linkedin"></div></a>
          <a className="social-link" href="https://github.com/map-ir" target="_blank"
          rel="noopener noreferrer"><div className="github"></div></a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
